import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { track } from "@/lib/track";

export const BetaPill = ({ className = "" }) => (
  <span
    className={`inline-flex items-center whitespace-nowrap rounded-full border border-amber-300/40 bg-amber-300/10 px-2 py-[3px] text-[10px] font-bold uppercase tracking-[0.14em] text-amber-300 md:py-0.5 ${className}`}
  >
    Beta
  </span>
);

const VARIANTS = {
  primary:
    "bg-gradient-green text-black shadow-[0_8px_32px_rgba(74,222,128,0.30)] hover:opacity-95",
  accent:
    "bg-gradient-accent text-white shadow-[0_8px_32px_rgba(59,130,246,0.35)] hover:opacity-95",
  ghost:
    "border border-cyan-300/40 text-cyan-200 hover:border-cyan-300/70 hover:text-white",
};

const AssessmentCta = ({ src, label = "Take your Free Level 0 Assessment", variant = "primary", className = "", showBeta = true, testId }) => (
  <Link
    to={`/assessment?src=${src}`}
    data-testid={testId || `assessment-cta-${src}`}
    onClick={() => track("assessment_cta_click", { src })}
    className={`group inline-flex min-h-[48px] items-center justify-center gap-2 rounded-full px-6 py-3 text-base font-semibold transition-all duration-300 ${VARIANTS[variant]} ${className}`}
  >
    <span>{label}</span>
    {showBeta && <BetaPill />}
    <ArrowRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-0.5" />
  </Link>
);

export default AssessmentCta;
